import React from 'react'
import Popover from 'react-popover'

const AbsolutePopover = ({ isOpen, preferPlace, tipSize, body, onOuterAction, left, top }) => (
  <Popover body={body} isOpen={isOpen} preferPlace={preferPlace} tipSize={tipSize} onOuterAction={onOuterAction}>
    <div
      style={{
        position: 'absolute',
        left,
        top,
      }}
    />
  </Popover>
)

export default AbsolutePopover
